<style lang="scss" scoped>
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  // width: calc(100% - 40px);
  min-width: 500px;

  // 设备效率面板
  .panel {
    // 详细指标
    .detail-target {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      // 左侧
      .left {
        display: flex;
        align-items: center;

        .icon {
          display: inline-block;
          width: 5px;
          height: 16px;
          background: #419fff;
        }

        .txt {
          display: inline-block;
          font-weight: 400;
          font-size: 16px;
          color: #303133;
          margin-left: 12px;
        }
      }

      // 右侧
      .right {
        display: flex;
        align-items: center;
      }
    }

    // 图表和表格
    .echart-table {
      margin-top: 8px;
      margin-bottom: 119px;
    }
  }
}

// 设备产量
.equipment-production {
  .info {
    display: flex;
    flex-direction: row-reverse;
    background: #f7f8fa;
    color: #44a1ff;
    padding: 5px;
  }

  .search {
    margin-top: 15px;
  }

  .table-container {
    .title {
      padding: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      margin-bottom: 15px;
      margin-left: -22px;

      .sign {
        position: static;
        width: 5px;
        height: 16px;
        left: 0px;
        top: 3px;
        background: #419fff;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 12px;
      }

      .txt {
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        line-height: 22px;
        color: #303133;
      }
    }
  }
}

// 产品详情
.production-detail {
  width: 100%;
  margin-left: 40px;
  color: #808184;
  margin-bottom: 34px;

  // 设备信息
  .equip-info {
    width: 80%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #606266;
    font-weight: bold;
  }

  // 时间信息
  .time-info {
    width: 70%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .item {
      flex: 1;
      display: flex;
      flex-direction: column;

      .title {
        width: 100;
        height: 50%;
        padding: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        // margin-bottom: 15px;
        margin-left: -22px;

        .sign {
          position: static;
          width: 5px;
          height: 16px;
          left: 0px;
          top: 3px;
          // background: #419FFF;
          flex: none;
          order: 0;
          flex-grow: 0;
          margin: 0px 12px;
        }

        .txt {
          font-size: 14px;
          font-family: Microsoft YaHei UI;
          line-height: 22px;
          color: #303133;
        }
      }

      .num {
        width: 100%;
        height: 50%;
        color: #808184;
        font-size: 20px;
        line-height: 20px;
        font-weight: bold;
        margin-left: 15px;
      }
    }

    .color-green {
      background: #64c136;
    }

    .color-orange {
      background: #e49d31;
    }

    .color-red {
      background: #f56d6d;
    }

    .color-gray {
      background: #8c8f95;
    }
  }

  // 表格
  .table {
    width: calc(100% - 40px);
    margin-top: 18px;

    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding: 5px;
      color: #909399;

      .item {
        width: 50%;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          width: 60%;
        }

        .value {
          width: 40%;
        }
      }
    }
  }
}
</style>

<template>
  <div class="container">
    <!-- 主界面 -->
    <div>
      <div class="panel">
        <!-- 表单 -->
        <div class="form">
          <el-form style="height:28px;" :model="energyTable.searchForm" :inline="true" size="mini">
            <el-form-item :label="$t('xuanzeyuefen')">
              <el-date-picker v-model="energyTable.searchForm.yearMonth" :clearable="false" value-format="yyyy-MM" type="month" format="yyyy-MM" :placeholder="$t('xuanzeyuefen')"> </el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('suoshuzuzhi')">
              <yi_data_select type="organization" :ids.sync="energyTable.searchForm.orgId"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')" label-width="110px" size="mini">
              <yi_data_select multiple type="equipment" :ids.sync="energyTable.searchForm.equipmentIds"></yi_data_select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDateTable" plain>{{ $t('sousuo') }} </el-button>
              <el-button type="default" @click="resetSearch" plain style="margin-left: 10px;">
                {{ $t('chongzhi') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 能耗表格 -->
        <div style=" margin-top: 24px;display: flex;align-items: center;justify-content: space-between;">
          <div class="left">
            <span class="icon"></span>
            <span class="txt">{{ $t('nenghaobiaoge') }}</span>
          </div>
          <div class="right">
            <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportExcel"> </el-button>
          </div>
        </div>
        <div class="echart-table">
          <div class="table">
            <el-table :data="energyTable.tableData" border size="mini" :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" v-loading="searchLoading" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
              <el-table-column v-for="(item, index) in energyTable.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" :sortable="item.sortable">
                <template slot-scope="scope">
                  <span v-if="['equipmentInfo.name', 'orgInfo.name'].includes(item.prop)" style="color: #606266">{{ getValueByPath(scope.row, item.prop) }}</span>
                  <span v-else style="color: #419FFF" @click="showDetail(scope.row, item.prop)">{{ scope.row.dateMap[item.prop] === undefined ? '-' : (scope.row.dateMap[item.prop]).toFixed(1) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 能耗详情 -->
    <el-drawer :visible.sync="energyDetailData.dialog" direction="rtl" size="60%" @closed="drawerClosed">
      <!-- 弹框标题 -->
      <div slot="title">
        <span style="font-size: 18px;font-weight: 400;margin-left:20px;color:#303133;">{{ $t('nenghaoxiangqing') }}</span>
      </div>
      <div class="production-detail">
        <!-- 设备信息 -->
        <div class="equip-info">
          <div>{{ $t('tongjishijian') }}: {{ energyDetailData.headInfo.shiftStartTime }} {{ $t('zhi4') }} {{ energyDetailData.headInfo.shiftEndTime }}</div>
          <div>{{ $t('shebeimingcheng') }}: {{ energyDetailData.headInfo.equipmentName }}</div>
          <div>{{ $t('haodianliang') }}: {{ energyDetailData.headInfo.totalEle }} KWH</div>
        </div>
        <!-- 详细指标 -->
        <div class="detail-target">
          <div class="right" style="padding-top: 20px;">
            <el-radio-group v-model="radio" size="mini" :border="true" fill="#ECF5FF" text-color="#419FFF">
              <el-radio-button :label="1">
                <i class="yicon yicon-numbers_line"></i>
              </el-radio-button>
              <el-radio-button :label="2">
                <i class="yicon yicon-list_check"></i>
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <!-- 图表和表格 -->
        <div class="echart-table">
          <!-- 图表 -->
          <div v-show="radio === 1">
            <div id="app" style="width: 1000px;height:400px;"></div>
          </div>
          <!-- 表格 -->
          <div class="table" v-show="radio === 2">
            <el-table :data="energyDetailData.tableData" v-loading="detailLoading" size="mini" border style="width: 100%" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
              <el-table-column v-for="(item, index) in energyDetailData.tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
const date = new Date();
const current = dayjs(date).format('YYYY-MM');
export default {
  name: 'web_energy_management_report_list',
  data() {
    return {
      searchLoading: false,
      exportLoading: false,
      detailLoading: false,
      // 可视窗口的宽度
      screenWidth: '',
      radio: 2,
      // 能耗表格数据
      energyTable: {
        searchForm: {
          yearMonth: current,
          orgId: undefined,
          equipmentIds: []
        },
        tableData: [],
        tableColumn: this.defaultTableColumn
      },
      defaultTableColumn: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentInfo.name'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'orgInfo.name'
        }
      ],
      // 能耗详情数据
      energyDetailData: {
        dialog: false,
        headInfo: {
          shiftStartTime: undefined,
          shiftEndTime: undefined,
          equipmentName: '',
          totalEle: 0
        },
        tableData: [],
        tableColumn: [
          {
            label: 'kaishishijian',
            prop: 'ks'
          },
          {
            label: 'jieshushijian',
            prop: 'ke'
          },
          {
            label: 'nenghao(KWH)',
            prop: 'v'
          }
        ],
        // 趋势图表对象
        chart: undefined,
        // 时间横轴
        timeAxis: [],
        // 数据纵轴
        dataAxis: [],
      }
    };
  },
  watch: {
    radio(value) {
      if (value) {
        this.setOption();
      }
    }
  },
  created() {
    this.getDateTable();
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    // 监听窗口变化
    window.onresize = () => {
      return () => {
        // 重新赋值最新窗口数据
        this.screenWidth = document.body.clientWidth;
      };
    };
  },
  methods: {
    setOption() {
      let chart = this.energyDetailData.chart;
      if (chart == undefined) {
        this.energyDetailData.chart = this.echarts.init(document.getElementById('app'));
      }
      let option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '20px',
          right: '20px',
          bottom: '60px',
          top: '16%',
          containLabel: true
        },
        legend: {
          left: 'center',
          top: '5%',
          textStyle: {
            color: '#000'
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: '#909399',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'rgba(255, 255, 255,1)',
            backgroundColor: '#F0F2F5',
            showDataShadow: true,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 14
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 14,
            color: '#909399'
          },
          data: this.energyDetailData.timeAxis
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              rotate: 0,
              textStyle: {
                color: '#909399'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                color: '#e4e7ed'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('haodianliang(du)'),
            type: 'line',
            lineStyle: {
              type: 'solid',
              color: '#419fff'
            },
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: '#FFFFFF',
                borderColor: '#419fff',
                borderWidth: 2
              }
            },
            data: this.energyDetailData.dataAxis
          }
        ]
      };
      this.energyDetailData.chart.setOption(option);
    },

    // 导出
    exportExcel() {
      this.exportLoading = true;
      this.http
        .get('/web/energy/consumption/summary/data/date/table', {
          params: this.energyTable.searchForm
        })
        .then(res => {
          const data = res.data;
          this.exportReportExcel(data);
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    // 导出报表的Excel
    exportReportExcel(data) {
      // 筛选出表头和prop
      let tableFirst = this.energyTable.tableColumn.map(column => this.$t(column.label));
      let tableProp = this.energyTable.tableColumn.map(column => column.prop);

      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        const item = data[i];
        for (let j = 0; j < tableProp.length; j++) {
          const prop = tableProp[j];
          let d;
          if (['equipmentInfo.name', 'orgInfo.name'].includes(prop)) {
            d = this.getValueByPath(item, prop);
          } else{
            d = item.dateMap[prop] === undefined ? '-' : item.dateMap[prop];
          }
          dataArr.push(d);
        }
        tableArr.push(dataArr);
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `能耗管理_能耗报表_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },

    // 打开能耗详情弹框
    showDetail(row, date) {
      this.energyDetailData.headInfo.equipmentName = row.equipmentInfo.name;
      this.energyDetailData.dialog = true;
      const yearMonth = this.energyTable.searchForm.yearMonth;
      const yearMonthPart = yearMonth.split('-');
      const datePart = date.split('-');
      const dateTime = new Date(yearMonthPart[0], parseInt(datePart[0], 10) - 1, datePart[1]).getTime();
      const params = {
        equipmentId: row.equipmentId,
        orgId: row.orgId,
        dateTime: dateTime
      };
      this.detailLoading = true;
      this.http
        .get('/web/energy/consumption/summary/data/date/energy/detail', {
          params: params
        })
        .then(res => {
          const data = res.data;
          let tableData = [];
          let timeAxis = [];
          let dataAxis = [];
          if (data && data.trendRoute && data.trendRoute.length > 0) {
            const trendRoute = data.trendRoute;
            for (let i = 0; i < trendRoute.length; i++) {
              const pointData = trendRoute[i];
              // 初始化表格数据
              const v = pointData.v != undefined ? eval(pointData.v).toFixed(1) : 0;
              const ks = eval(pointData.ks);
              const ke = eval(pointData.ke);
              const obj = {
                ks: dayjs(ks).format('YYYY-MM-DD HH:mm:ss'),
                ke: dayjs(ke).format('YYYY-MM-DD HH:mm:ss'),
                v: v
              }
              tableData.push(obj);
              // 初始化图表数据
              const t = dayjs(ks).format('HH:mm') + '-' + dayjs(ke).format('HH:mm');
              timeAxis.push(t);
              dataAxis.push(v);
            }
          }
          this.energyDetailData.tableData = tableData;
          this.energyDetailData.timeAxis = timeAxis;
          this.energyDetailData.dataAxis = dataAxis;
          this.energyDetailData.headInfo.shiftStartTime = dayjs(data.shiftStartTime).format('YYYY-MM-DD HH:mm:ss');
          this.energyDetailData.headInfo.shiftEndTime = dayjs(data.shiftEndTime).format('YYYY-MM-DD HH:mm:ss');
          this.energyDetailData.headInfo.totalEle = data.totalValue != undefined ? data.totalValue.toFixed(1) : 0;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },

    // 获取能耗日期表格数据
    getDateTable() {
      this.searchLoading = true;
      // 设置指定月份的所有日期lebel
      let dates = this.getDates();
      let tableColumn = this.utils.copy(this.defaultTableColumn);
      for (let i = 0; i < dates.length; i++) {
        const date = dates[i];
        const dateObj = {
          label: date,
          prop: date
        };
        tableColumn.push(dateObj);
      }
      this.energyTable.tableColumn = tableColumn;

      this.http
        .get('/web/energy/consumption/summary/data/date/table', {
          params: this.energyTable.searchForm
        })
        .then(res => {
          const data = res.data;
          if (data && data.length > 0) {
            this.energyTable.tableData = data;
          } else {
            this.energyTable.tableData = [];
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },

    // 重置搜索
    resetSearch() {
      this.energyTable.searchForm = {
        yearMonth: current,
        orgId: undefined,
        equipmentIds: []
      };
      this.getDateTable();
    },

    // 获取指定年月的所有日期
    getDates() {
      let yearMonth = this.energyTable.searchForm.yearMonth;
      let parts = yearMonth.split('-');
      let year = parseInt(parts[0], 10);
      let month = parseInt(parts[1], 10);
      // 注意JavaScript的月份是从0开始的，所以要减1
      month = month - 1;
      // 创建一个Date对象表示该月的第一天
      let date = new Date(year, month, 1);
      // 获取下一个月的第一天（注意这里月份会自动递增）
      let nextMonthFirstDay = new Date(year, month + 1, 1);
      // 创建一个数组来存储该月的所有日期
      let dates = [];
      // 遍历整个月份
      while (date < nextMonthFirstDay) {
        // 使用getDate()方法获取当前日期（1-31）
        let d = new Date(date);
        let ds = dayjs(d).format('M-D');
        dates.push(ds); // 或者只存储日期的数字部分：dates.push(date.getDate());
        // 递增一天
        date.setDate(date.getDate() + 1);
      }
      return dates;
    },

    // 从嵌套对象中取值
    getValueByPath(obj, path) {
      const parts = path.split('.');
      let current = obj;
      for (let i = 0; i < parts.length; i++) {
        if (current[parts[i]] !== undefined) {
          current = current[parts[i]];
        } else {
          // 如果路径中的某一部分不存在，返回undefined
          return undefined;
        }
      }
      return current;
    },

    // 抽屉关闭时调用
    drawerClosed() {
      this.radio = 2;
    }
  }
};
</script>
